import React, { useMemo } from "react";
import { useIntl } from "react-intl";
import PropTypes from "prop-types";

import "./LocationFilter.scss";
import Dropdown from "components/atoms/Dropdown/Dropdown";
import testIds from "constants/testIds";
import useSortedPaymentLocations from "hooks/useSortedPaymentLocations";

function LocationFilter(props) {
  const { disableAll, onChange } = props;
  const intl = useIntl();
  const DEFAULT_LABEL = intl.formatMessage({
    id: "components.organisms.listing.allLocations",
    defaultMessage: "All Locations",
  });

  const sortedLocations = useSortedPaymentLocations();

  const sortedLocationsWithAll = useMemo(() => [{ label: DEFAULT_LABEL, value: "" }, ...sortedLocations], [sortedLocations]);

  return (
    <div className="filter-dropdown-wrapper">
      <Dropdown
        options={disableAll ? sortedLocations : sortedLocationsWithAll}
        onChange={(item) => onChange(item.value)}
        defaultValue={disableAll ? sortedLocations[0].label : DEFAULT_LABEL}
        data-testid={testIds.LIST_LOCATION_FILTER_DROPDOWN}
      />
    </div>
  );
}

LocationFilter.propTypes = {
  disableAll: PropTypes.bool,
  onChange: PropTypes.func,
};

LocationFilter.defaultProps = {
  onChange: () => {},
  disableAll: false,
};

export default LocationFilter;
